/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Date_StartInputs */



/**
* | output |
* | --- |
* | "Custom Date Start" |
*
* @param {Custom_Date_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_date_start = /** @type {((inputs?: Custom_Date_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Date_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Début de période personnalisée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefiniertes Startdatum")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data di inizio personalizzata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользовательская дата начала")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha de inicio personalizada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自定义日期开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタム日付開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम तिथि प्रारंभ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Data de início personalizada")
	return /** @type {LocalizedString} */ ("Custom Date Start")
});